import { SVGProps } from "react";
const HeartSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={17}
    viewBox="0 0 18 17"
    fill="none"
    {...props}
  >
    <path
      fill="#FF403D"
      fillRule="evenodd"
      stroke="#FF403D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9 2.736c.632-.738 1.724-1.568 3.388-1.568 2.91 0 4.862 2.732 4.862 5.275 0 5.318-6.62 9.392-8.25 9.392S.75 11.76.75 6.443c0-2.543 1.952-5.275 4.862-5.275 1.664 0 2.756.83 3.388 1.568Z"
      clipRule="evenodd"
    />
  </svg>
);
export default HeartSvg;
